import { getField, updateField } from 'vuex-map-fields';

const emptyDescription = () => {
    return {
        familyHistory: null,
        familyBeauty: null,
        familyEverydayLife: null
    };
};

export default {
    namespaced: true,
    state: {
        description: emptyDescription()
    },
    getters: {
        getFields (state) {
            return getField(state.description);
        },
        getDescription (state) {
            return state.description;
        }
    },
    mutations: {
        updateFields (state, field) {
            updateField(state.description, field);
        },
        clearDescription (state, field) {
            state.description = emptyDescription();
        },
        setDescription (state, fields) {
            state.description = fields;
        }
    }
};
